import { createAction, ActionWithPayload } from 'helpers/redux-actions.helper'
import { ActionsUnion } from 'helpers/types.helper'
import { IEnrolModel } from 'models/enrol.model'
import { SynchronousCourseEnrolBody } from 'api/administration/applications/updateSynchronousCourseEnrol'
import { EnrolListAction } from '../sagas/enrols/list.saga'
import { EnrolAdminListAction } from '../sagas/enrols/admin-list.saga'

export const ENROL_CREATE = 'ENROL_CREATE'
export const ENROL_CREATE_SUCCESS = 'ENROL_CREATE_SUCCESS'
export const ENROL_EDIT = 'ENROL_EDIT'
export const ENROL_EDIT_SUCCESS = 'ENROL_EDIT_SUCCESS'
export const ENROL_LIST_GET = 'ENROL_LIST_GET'
export const ENROL_LIST_SUCCESS = 'ENROL_LIST_SUCCESS'
export const ENROL_ADMIN_LIST_GET = 'ENROL_ADMIN_LIST_GET'
export const ENROL_ADMIN_LIST_SUCCESS = 'ENROL_ADMIN_LIST_SUCCESS'
export const ENROL_ADMIN_EDIT = 'ENROL_ADMIN_EDIT'
export const ENROL_ADMIN_SYNCHRONOUS_COURSE_ENROL_EDIT =
  'ENROL_ADMIN_SYNCHRONOUS_COURSE_ENROL_EDIT'
export const ENROL_ADMIN_EDIT_SUCCESS = 'ENROL_ADMIN_EDIT_SUCCESS'
export const ENROL_CREATE_MANUALLY_ASSIGNED = 'ENROL_CREATE_MANUALLY_ASSIGNED'
export const ENROL_CREATE_MANUALLY_ASSIGNED_SUCCESS =
  'ENROL_CREATE_MANUALLY_ASSIGNED_SUCCESS'

export interface EditSynchronousCourseEnrolPayload {
  data: SynchronousCourseEnrolBody
  onSuccess: () => void
  onError?(): void
}

export interface EnrolCreatePayload {
  enrol: IEnrolModel
  getCourse: boolean
  isSynchronous?: boolean
  showToast?: boolean
}

export type EnrolCreateAction = ActionWithPayload<
  typeof ENROL_CREATE,
  EnrolCreatePayload
>

export interface EnrolCreateManuallyPayload {
  enrol: IEnrolModel
  userIds: number[]
}

export type EnrolCreateManuallyAction = ActionWithPayload<
  typeof ENROL_CREATE_MANUALLY_ASSIGNED,
  EnrolCreateManuallyPayload
>

export const Actions = {
  enrolListSuccess: (data: IEnrolModel[]) =>
    createAction(ENROL_LIST_SUCCESS, data),
  enrolCreate: (data: EnrolCreatePayload) => createAction(ENROL_CREATE, data),
  enrolCreateSuccess: (data: IEnrolModel) =>
    createAction(ENROL_CREATE_SUCCESS, data),
  edit: (data: IEnrolModel) => createAction(ENROL_EDIT, data),
  editAdmin: (data: IEnrolModel) => createAction(ENROL_ADMIN_EDIT, data),
  editSynchronousCourseEnrol: (data: EditSynchronousCourseEnrolPayload) =>
    createAction(ENROL_ADMIN_SYNCHRONOUS_COURSE_ENROL_EDIT, data),
  enrolEditSuccess: (data: IEnrolModel) =>
    createAction(ENROL_EDIT_SUCCESS, data),
  getEnrolList: (payload?: EnrolListAction['payload']) =>
    createAction(ENROL_LIST_GET, payload),
  enrolAdminListSuccess: (data: IEnrolModel[]) =>
    createAction(ENROL_ADMIN_LIST_SUCCESS, data),
  enrolAdminListReload: (payload?: EnrolAdminListAction['payload']) =>
    createAction(ENROL_ADMIN_LIST_GET, payload),
  enrolCreateManuallyAssigned: (data: IEnrolModel) =>
    createAction(ENROL_CREATE_MANUALLY_ASSIGNED, data),
  enrolCreateManuallyAssignedSuccess: (data: IEnrolModel) =>
    createAction(ENROL_CREATE_MANUALLY_ASSIGNED_SUCCESS, data),
}

export type Actions = ActionsUnion<typeof Actions>
